import { RootState } from "../../state";

export const isLikedSelector = (state: RootState, postId: number): boolean => state.post_likes[postId] || false;



// WEBPACK FOOTER //
// ./frontend/src/post_likes/selectors/index.ts